// extracted by mini-css-extract-plugin
export default {"disabled":"SwitchWidget_disabled__3JiBZ","container":"SwitchWidget_container__xSsFM","switch":"SwitchWidget_switch__-Y5X4","slider":"SwitchWidget_slider__6ZJF0"};